module.exports = __webpack_public_path__ + "fonts/BebasNeueRegular.c264da1a.woff2";